export default __webpack_public_path__ + "static/media/5.f43e58e9.jpg";